export default __webpack_public_path__ + "static/media/Category-21.ca6b6b1f.jpg";